import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import { Sparkles } from 'lucide-react';

import { StatusBadge } from '@/presentation/components/index.js';

interface Props {
    status: string;
    aiAnalysisInProgressLabel: string;
}

export function DevelopmentListStatusCell({ status, aiAnalysisInProgressLabel }: Props) {
    return (
        <Stack direction="row" spacing={0.5} alignItems="center">
            <StatusBadge status={status} />
            {status === 'EF_EM_VALIDACAO_IA' && (
                <Tooltip title={aiAnalysisInProgressLabel}>
                    <Chip icon={<Sparkles size={12} />} label="IA" size="small" color="info" variant="outlined" sx={{ height: 22 }} />
                </Tooltip>
            )}
        </Stack>
    );
}
